export default "__VITE_ASSET__B9lxdzk7__"